import Util from '@/helper/Utility';

export function UserInfoModel(profile) {
    this.firstname = profile.FirstName || '';
    this.lastname = profile.LastName || '';
    this.contact_number = profile.ContactNumber || '';
    this.birthdate = profile.BirthDate || null;
    this.gender = profile.Gender || '';
    this.email = profile.Email || '';
    this.idCard = profile.IDCard || '';
    this.profileImageUrl = profile.profileImageUrl || '',
    this.point = profile.Point || '',
    this.address = profile.Address || '',
    this.imageUrl = profile.ImageUrl || '',
    this.birthDate = profile.BirthDate || '',
    this.bzbsPasswordType = profile.BzbsPasswordType || '',

    this.getParamsRegister = function () {
        const params = {

        };

        return Util.cleanObjectEmptyStr(params);
    };

    this.getParamsUpdateProfile = function () {
        const params = {

        };

        return Util.cleanObjectEmptyStr(params);
    };
    this.getParamsProfile = function (){
        let params = {
            idCard: this.idCard,
            contact_number: this.contact_number
        }
        return Util.cleanObjectEmptyStr(params);
    }
}
